<template>
  <nav class="navbar">
    <div class="container-fluid">
      <div class="d-flex align-items-center justify-content-between row no-gutters flex-grow-1">

        <div class="d-none d-lg-block col-2">
          <router-link to="/">
            <!--<img src="@/assets/icons/logo.svg" class="img-fluid logo">-->
          </router-link>
        </div>
        <div class="d-block d-lg-none col-2">
          <!--<img src="@/assets/icons/menu-mobile.svg" class="img-fluid menu__icon" v-on:click="showSideNav = true;">-->
       </div>

     </div>
   </div>
   <div class="toggle__navbar" :class="{'active': showSideNav == true}">
     <!--<img src="@/assets/icons/close--white.svg" class="img-fluid close__nav" v-on:click="showSideNav = false;">-->
      <div class="sidebar">
        <div class="position-relative d-flex flex-column align-items-center">
          <div class="nav__text">
            <div class="nav__point--text" :class="{'active' : activeHover == 0}" v-on:click="moveToSection(1, 0)" v-html="$t('GLOBAL_MENU_01')"></div>
            <div class="nav__point--text" :class="{'active' : activeHover == 1}" v-on:click="moveToSection(4, 0)"  v-html="$t('GLOBAL_MENU_02')"></div>
            <div class="nav__point--text" :class="{'active' : activeHover == 2}" v-on:click="moveToSection(5, 0)"  v-html="$t('GLOBAL_MENU_03')"></div>
            <div class="nav__point--text" :class="{'active' : activeHover == 3}" v-on:click="moveToSection(6, 0)"  v-html="$t('GLOBAL_MENU_04')"></div>
            <div class="nav__point--text" :class="{'active' : activeHover == 4}" v-on:click="moveToSection(7, 0)"  v-html="$t('GLOBAL_MENU_05')"></div>
            <div class="nav__point--text" :class="{'active' : activeHover == 5}" v-html="$t('GLOBAL_CLOSE')" v-on:click="closeModule"></div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { EventBus } from '@/main';
import { gsap, TimelineMax, CSSPlugin } from 'gsap/all'

gsap.registerPlugin(CSSPlugin)

export default {
  name: "Navigation",
  components: {
    EventBus
  },
  data(){
    return {
      sites: "",
      timeline: '',
      sound: '',
      soundPlaying: false,
      showSideNav: false,
      lang: "",
      country: "",
      activeHover: -1,
      active: 1,
      highlightIndex: 0,
    }
  },
  watch: {
    '$store.state.currentNav': function() {
      this.active = this.$store.state.currentNav;
      this.highlightIndex = this.$store.state.currentNav;
      console.log(this.$store.state.currentNav)
    }
  },
  methods: {
    getKapitel(kapitel){
      return "0"+kapitel;
    },
    toggleSound() {
      if (this.soundPlaying) {
        this.sound.pause()
      } else {
        this.sound.play();
      }
      this.soundPlaying = !this.soundPlaying;
    },
    pauseSound(keyword) {
      console.log(keyword, this.soundPlaying);
      if (this.soundPlaying) {
        if (keyword == 'play') {
          this.sound.play()
        } else if (keyword == 'pause') {
          this.sound.pause();
        }
      }
    },
    openNav(){
      const trigger = document.querySelector('#navbarNav').classList
      if (trigger.contains('show')) {
        //trigger.toggle('show')
        this.timeline.reverse()
      } else {
        trigger.add('show')
        this.timeline.restart()
      }
    },
    closeNav(chapter){
      this.timeline.reverse()
      if (chapter > 0) {
        EventBus.$emit('silentMoveToSection', [chapter]);
      }
    },
    reverseFunction() {
      document.querySelector('#navbarNav').classList.toggle('show');
    },
    moveToSection(chapter, section) {
      this.showSideNav = false;
      this.active = chapter;
      EventBus.$emit('moveToSection', [chapter, section]);
    },
    resetActive(){
      let num = this.active;
      this.activeHover = -1;
    },
    setActive(num){
      this.activeHover = num;
    },
    closeModule(){
      window.open('/'+ this.country + '_' + this.lang + '/brand-choice/' ,"_self")
    },
  },
  mounted() {
    this.lang = this.$store.getters.lang;
    this.country = this.$store.getters.country;
    this.timeline = new TimelineMax({onReverseComplete : function () {
        document.querySelector('#navbarNav').classList.toggle('show');
      }})
    this.timeline.from('.bg', 0.25, {yPercent: -100});
    this.timeline.staggerFrom('.nav__item', 0.25, {opacity: 0}, 0.2);
    this.timeline.from('.nav__item--close', 0.25, {opacity: 0});
  },



}
</script>

<style scoped>

</style>